module.exports = __webpack_public_path__ + "static/media/favicon-cuhk925.b0130934.ico";